import React from 'react';
import { Check, Shield, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export interface ComboCardProps {
  title: string;
  price: string;
  originalPrice: string;
  discount: string;
  features: string[];
  description: string;
  isRecommended?: boolean;
  isPremium?: boolean;
  onBuy: () => void;
  image?: string;
}
export function ComboCard({
  title,
  price,
  originalPrice,
  discount,
  features,
  description,
  isRecommended,
  isPremium,
  onBuy,
  image
}: ComboCardProps) {
  return <motion.div whileHover={isRecommended ? {
    scale: 1.02
  } : {}} className={`relative flex flex-col h-full rounded-2xl overflow-hidden ${isRecommended ? 'bg-zinc-900 border-2 border-yellow-500 shadow-[0_0_30px_rgba(234,179,8,0.15)] z-10 scale-100 md:scale-105' : 'bg-zinc-900/80 border border-zinc-800'}`} data-id="element-1">
      {isRecommended && <div className="bg-yellow-500 text-black text-center py-1 text-xs font-black uppercase tracking-widest" data-id="element-2">
          Más Vendido / Recomendado
        </div>}

      {isPremium && <div className="bg-zinc-800 text-gray-300 text-center py-1 text-xs font-bold uppercase tracking-widest border-b border-zinc-700" data-id="element-3">
          Nivel Avanzado
        </div>}

      <div className="p-6 flex-1 flex flex-col" data-id="element-4">
        {/* Header */}
        <div className="mb-6" data-id="element-5">
          <h3 className={`text-xl font-black uppercase mb-2 ${isRecommended ? 'text-yellow-500' : 'text-white'}`} data-id="element-6">
            {title}
          </h3>
          <p className="text-gray-400 text-sm min-h-[40px]" data-id="element-7">{description}</p>
        </div>

        {/* Image if available */}
        {image && <div className="mb-6 rounded-lg overflow-hidden border border-zinc-800 bg-zinc-950 flex items-center justify-center" data-id="element-8">
            <img src={image} alt={title} className="w-full h-auto max-h-52 object-contain" data-id="element-9" />
          </div>}

        {/* Pricing */}
        <div className="mb-6" data-id="element-10">
          <div className="flex items-center gap-2 mb-1" data-id="element-11">
            <span className="text-gray-500 line-through text-sm" data-id="element-12">
              ARS {originalPrice}
            </span>
            <span className="bg-red-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-13">
              {discount} OFF
            </span>
          </div>
          <div className="flex items-baseline gap-1" data-id="element-14">
            <span className="text-sm text-gray-400 font-bold" data-id="element-15">ARS</span>
            <span className="text-4xl font-black text-white tracking-tight" data-id="element-16">
              {price}
            </span>
          </div>
        </div>

        {/* Features */}
        <div className="flex-1 mb-8" data-id="element-17">
          <ul className="space-y-3" data-id="element-18">
            {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-19">
                <div className={`mt-0.5 p-0.5 rounded-full ${isRecommended ? 'bg-yellow-500/20' : 'bg-zinc-800'}`} data-id="element-20">
                  <Check className={`w-3 h-3 ${isRecommended ? 'text-yellow-500' : 'text-gray-400'}`} data-id="element-21" />
                </div>
                <span className="text-sm text-gray-300 leading-tight" data-id="element-22">
                  {feature}
                </span>
              </li>)}
          </ul>
        </div>

        {/* CTA */}
        <button onClick={onBuy} className={`w-full py-4 rounded-lg font-black uppercase tracking-wider transition-all duration-200 flex items-center justify-center gap-2 ${isRecommended ? 'bg-yellow-500 text-black hover:bg-yellow-400 hover:shadow-[0_0_20px_rgba(234,179,8,0.4)]' : 'bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700'}`} data-id="element-23">
          {isRecommended ? 'Quiero Acceso Inmediato' : 'Seleccionar Pack'}
        </button>

        <div className="mt-3 flex justify-center items-center gap-2 text-[10px] text-gray-500" data-id="element-24">
          <Lock className="w-3 h-3" data-id="element-25" />
          <span data-id="element-26">Pago 100% Seguro</span>
        </div>
      </div>
    </motion.div>;
}